<template>
  <div class="text-h6 text-sm-h5 text-md-h4 font-weight-bold">
    <slot name="default" />

    <v-sheet
      :class="{ 'mt-1': !xsOnly }"
      color="black"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
export default {
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    width() {
      const size = {
        xs: "30px",
        sm: "40px",
      };

      return size[this.$vuetify.breakpoint.name] || "75px";
    },
    height() {
      const size = {
        xs: "3",
        sm: "3",
      };

      return size[this.$vuetify.breakpoint.name] || "4px";
    },
  },
};
</script>
